export default "__VITE_ASSET__CeDMgeqc__"